mutation teacherUpdate($id: ID!, $forwardingNumber: String) {
  teacherUpdate(id: $id, forwardingNumber: $forwardingNumber) {
    id
    forwardingNumber
    formattedForwardingNumber
    team {
      id
      name
    }
    teacherPhoneNumbers {
      id
      number
      formattedNumber
    }
  }
}
